/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-empty-function */
export type LambdaContext = any;
export type LambdaEvent = any;
export const lambdaRequestTracker = (..._args: any) => (..._args2: any) => {};
export const pinoLambdaDestination = (_arg: any) => ({} as any);
export const StructuredLogFormatter = class {};
